import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { TextField, Box, Typography } from "@mui/material";
import FirstNameField from "./components/first_name";
import LastNameField from "./components/last_name";
import GenderField from "./components/gender";
import ShortTextField from "./components/text";
import DOBField from "./components/dob";
import SelectField from "./components/select";
import BVNField from "./components/bvn";
import SelfieField from "./components/selfie";
import ImageField from "./components/image";
import FileField from "./components/file";
import DocumentField from "./components/document";
import ParagraphField from "./components/paragraph";
import SignaturePadField from "./components/signature_pad";
import NINField from "./components/nin";
import NumberField from "./components/number";
import GoogleAddressField from "./components/google_address";
import EmailAddressField from "./components/email_address";
import PhoneNumberField from "./components/phone_number";
import PasswordField from "./components/password";
import CurrentGPSLocation from "./components/gps_location";
import GeoLocationMapPoint from "./components/geo_point";
import DateField from "./components/date";
import MultiSelectField from "./components/multi_select";
import VideoRecorder from "./components/video";
import AudioRecorder from "./components/audio";

function FormSectionBuilder({ section }) {
  const [sectionFields, setSectionFields] = useState([]);

  //   async function buildSectionField(field) {
  //     const compModule = import(`app/data_forms/components/${field.type}`);
  //     const LoadedComponent = compModule.default;
  //     return <LoadedComponent displayName={field.display_name} name={field.code} />;
  //   }

  // const componentTemplates = {
  //   first_name: (
  //     <FirstNameField displayName={field.display_name} name={field.code} options={field.options} />
  //   ),
  //   last_name: (
  //     <LastNameField displayName={field.display_name} name={field.code} options={field.options} />
  //   ),
  //   email_address: (
  //     <EmailAddressField
  //       displayName={field.display_name}
  //       name={field.code}
  //       options={field.options}
  //     />
  //   ),
  //   gender: (
  //     <GenderField displayName={field.display_name} name={field.code} options={field.options} />
  //   ),
  //   dob: <DOBField displayName={field.display_name} name={field.code} options={field.options} />,
  //   bvn: <BVNField displayName={field.display_name} name={field.code} options={field.options} />,
  //   nin: <NINField displayName={field.display_name} name={field.code} options={field.options} />,
  //   selfie: (
  //     <SelfieField displayName={field.display_name} name={field.code} options={field.options} />
  //   ),
  //   image: (
  //     <ImageField displayName={field.display_name} name={field.code} options={field.options} />
  //   ),
  //   file: <FileField displayName={field.display_name} name={field.code} options={field.options} />,
  //   document: (
  //     <DocumentField displayName={field.display_name} name={field.code} options={field.options} />
  //   ),
  //   signature: (
  //     <SignaturePadField
  //       displayName={field.display_name}
  //       name={field.code}
  //       options={field.options}
  //     />
  //   ),
  //   text: <TextField displayName={field.display_name} name={field.code} options={field.options} />,
  //   number: (
  //     <NumberField displayName={field.display_name} name={field.code} options={field.options} />
  //   ),
  //   paragraph: (
  //     <ParagraphField displayName={field.display_name} name={field.code} options={field.options} />
  //   ),
  //   google_address: (
  //     <GoogleAddressField
  //       displayName={field.display_name}
  //       name={field.code}
  //       options={field.options}
  //     />
  //   ),
  //   select: (
  //     <SelectField displayName={field.display_name} name={field.code} options={field.options} />
  //   ),
  // };

  function buildSectionField(field) {
    // console.log(field.code);
    // let component = componentTemplates[field.type];
    // if (component === null || typeof component === "undefined") {
    //   component = (
    //     <TextField displayName={field.display_name} name={field.code} options={field.options} />
    //   );
    // }

    let component = null;
    switch (field.type) {
      case "first_name":
        component = (
          <FirstNameField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "last_name":
        component = (
          <LastNameField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "gender":
        component = (
          <GenderField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "dob":
        component = (
          <DOBField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "date":
        component = (
          <DateField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "bvn":
        component = (
          <BVNField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "nin":
        component = (
          <NINField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "selfie":
        component = (
          <SelfieField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "image":
        component = (
          <ImageField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "file":
        component = (
          <FileField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "document":
        component = (
          <DocumentField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "signature":
        component = (
          <SignaturePadField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "text":
        component = (
          <ShortTextField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "number":
        component = (
          <NumberField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "paragraph":
        component = (
          <ParagraphField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "google_address":
        component = (
          <GoogleAddressField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "email_address":
        component = (
          <EmailAddressField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "phone_number":
        component = (
          <PhoneNumberField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "select":
        component = (
          <SelectField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "password":
        component = (
          <PasswordField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "gps_location":
        component = (
          <CurrentGPSLocation
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "geo_point":
        component = (
          <GeoLocationMapPoint
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "multi_select":
        component = (
          <MultiSelectField
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "audio":
        component = (
          <AudioRecorder
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      case "video":
        component = (
          <VideoRecorder
            displayName={field.display_name}
            // name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
        break;
      default:
        component = (
          <TextField
            displayName={field.display_name}
            name={field.code}
            fieldRef={field.reference}
            options={field.options}
          />
        );
    }

    return component;
  }

  useEffect(() => {
    const fields = [];
    section.fields.map((param) => {
      // console.log(param);
      const field = buildSectionField(param);
      fields.push(field);
      return false;
    });
    // console.log(fields);
    setSectionFields(fields);
  }, [section]);

  return (
    <Box>
      <Box>
        <Typography variant="caption" fontWeight="regular">
          {section.title.toUpperCase()}
        </Typography>
      </Box>
      {section.description !== null ? (
        <Box>
          <Typography variant="caption" fontWeight="light">
            {section.description}
          </Typography>
        </Box>
      ) : (
        <> </>
      )}

      {sectionFields.map((field) => (
        <Box mt={2} mb={3}>
          {field}
        </Box>
      ))}
    </Box>
  );
}
// Typechecking props of the Transaction
FormSectionBuilder.propTypes = {
  section: PropTypes.isRequired,
};
export default FormSectionBuilder;
